/**
 * This module contains visualization Web Components. These can be used directly
 * but also serve as building blocks that can be used to build higher-order
 * components, i.e. components that incorporate both HTML elements and
 * visualizations.
 *
 * @module viz components
 */
export * from './lis-legend-element';
export * from './lis-phylotree-element';
